import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/apps/blogtostart/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/root/apps/blogtostart/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["UiI18nProvider"] */ "/root/apps/blogtostart/src/components/i18n-ui/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileMenu"] */ "/root/apps/blogtostart/src/components/marketing/mobile-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DesktopNav"] */ "/root/apps/blogtostart/src/components/marketing/nav-links.tsx");
